import { Controller, FetchOptions, Result } from 'bernie-core';
import { ZendeskSsoExecutor } from '../../components';
import { withSecurity } from '../../components/auth';

export class ZendeskSsoController implements Controller {
  public routeName = 'zendesksso';
  public pageId = 'pages.zendesksso';
  public path = '/affiliate-hub/zendesk/access';
  public exact = true;
  public bundles = [];
  public deferTo = ZendeskSsoExecutor;

  public component = withSecurity(this.deferTo, this.path, false);

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Affiliate Hub Zendesk SSO' });
  }
}
